import { PayloadAction, createReducer } from "@reduxjs/toolkit";
import type { ApiKeyDto } from "../../data/models/schemas";

import {
    API_KEYS_HIDE_MODAL,
    API_KEYS_HIDE_RESULT_MODAL,
    API_KEYS_SHOW_MODAL,
    createApiKey,
    deleteApiKey,
    getApiKeys,
} from "../actions/apiKeys";

export type IApiKey = ApiKeyDto;

export type IApiKeyState = {
    apiKeys: IApiKey[];
    showCreateModal: boolean;
    showCreateResultModal: boolean;
    createdApiKey?: IApiKey | null;
    loaded: boolean;
};

const getDefaultState = (): IApiKeyState => {
    return {
        apiKeys: [],
        showCreateModal: false,
        showCreateResultModal: false,
        loaded: false,
    };
};

export const apiKeys = createReducer(getDefaultState(), (builder) => {
    builder.addCase(API_KEYS_SHOW_MODAL, (state) => {
        state.showCreateModal = true;
    });
    builder.addCase(API_KEYS_HIDE_MODAL, (state) => {
        state.showCreateModal = false;
    });
    builder.addCase(API_KEYS_HIDE_RESULT_MODAL, (state) => {
        state.showCreateResultModal = false;
        state.createdApiKey = null;
    });
    builder.addCase(
        getApiKeys.success,
        (state, action: PayloadAction<{ keys?: IApiKey[] }>) => {
            state.apiKeys = action.payload.keys || [];
            state.showCreateModal = false;
            state.loaded = true;
        }
    );
    builder.addCase(
        deleteApiKey.success,
        (state, action: PayloadAction<{ keys?: IApiKey[] }>) => {
            state.apiKeys = action.payload.keys || [];
        }
    );
    builder.addCase(
        createApiKey.success,
        (state, action: PayloadAction<{ apiKey?: IApiKey }>) => {
            state.showCreateModal = false;
            state.showCreateResultModal = true;
            state.createdApiKey = action.payload.apiKey || null;
        }
    );
});
